module.exports = __webpack_public_path__ + "media/images/favicon-39610c21.png";